/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { MixedListUIModuleContentTreatment } from './mixed-list-uimodule-content-treatment';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface MixedListUiModuleBody
 */
export interface MixedListUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    moduleType: MixedListUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof MixedListUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof MixedListUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof MixedListUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof MixedListUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof MixedListUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {boolean}
     * @memberof MixedListUiModuleBody
     */
    isPlaylist?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MixedListUiModuleBody
     */
    useCollectionTitle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MixedListUiModuleBody
     */
    reorderBasedOnRecommendation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    contentListId: string;
    /**
     * 
     * @type {MixedListUIModuleContentTreatment}
     * @memberof MixedListUiModuleBody
     */
    contentTreatment: MixedListUIModuleContentTreatment;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    landscapeFillImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    portraitFillImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    sponsorLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    trackingPixelUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    sponsorStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MixedListUiModuleBody
     */
    sponsorEndDate?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MixedListUiModuleBodyModuleTypeEnum {
    MIXED_LIST = 'MIXED_LIST'
}



